var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 57,
    viewBox: "0 0 48 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xC3\x8Dcone - Alta Dura\xC3\xA7\xC3\xA3o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.1373 54.9584C23.7498 55.0692 23.2793 55.0692 22.8919 54.9584C1 48.6483 1 28.0018 1 14.3021C1 11.8666 2.96501 9.95695 5.40051 9.92927C9.66265 9.9016 16.471 8.57314 23.5007 1.95853C30.5305 8.57314 37.3665 9.9016 41.601 9.92927C44.0365 9.92927 46.0015 11.8666 46.0015 14.3021C46.0015 28.0018 46.0015 48.6483 24.1096 54.9584H24.1373Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.5005 41.2583C30.3482 41.2583 35.8994 35.7071 35.8994 28.8594C35.8994 22.0116 30.3482 16.4604 23.5005 16.4604C16.6528 16.4604 11.1016 22.0116 11.1016 28.8594C11.1016 35.7071 16.6528 41.2583 23.5005 41.2583Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.8555 30.1052L21.0936 33.3433L28.8706 25.5663",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/Shield.78b3a7c02607409e6e3f0cbaf7eaa5b4.svg";
export { ForwardRef as ReactComponent };